import DataMapper from './DataMapper'
import CaseHistoryRM from '../responsemodel/CaseHistoryRM'
import CaseHistory from '../../models/CaseHistory'

class CaseHistoryDataMapper extends DataMapper<CaseHistoryRM, CaseHistory> {
  map = (rm: CaseHistoryRM) => new CaseHistory(rm.data, rm.by, rm.state, rm.on, rm.difference)
}

export default CaseHistoryDataMapper
